module.exports = __webpack_public_path__ + "img/service_tip.2914a5a4.png";